import React, { useState, useCallback, useEffect } from "react";
import {
  Page,
  Card,
  Modal,
  Text,
  Spinner,
  Image,
  Loading,
  Button,
  DataTable,
  ButtonGroup,
  Toast,
  Checkbox,
  FormLayout,
  Filters,
  TextField,
  Badge,
  Frame,
  InlineError,
  ChoiceList,
  Thumbnail,
  EmptySearchResult,
  Tag,
  Select,
} from "@shopify/polaris";
import axios from "../../Assets/Lib/axios";
import { useRef } from "react";
import emptyListImage from "../../Assets/Images/emptyList.svg";
import { useNavigate } from "react-router-dom";
import { MultiSelect } from "react-multi-select-component";
// import Select from "react-select";
import Pagination from "@mui/material/Pagination";
import EllipsisText from "react-ellipsis-text";
import { useParams } from "react-router-dom";
import Select2 from "react-select";

const Notes = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const addEditState = useRef("");
  const perPage = 100;
  const [ts, setTs] = useState("");
  const [availability, setAvailability] = useState("");
  const [queryValue, setQueryValue] = useState("");
  const [page, setPage] = useState(1);
  const [pageObject, setPageObject] = useState({
    isLoading: true,
    isSaving: false,
    tableItems: [],
    tableTotalPages: 0,
    isListEmpty: false,
  });
  const handleAddNote = () => {
    navigate(`/admin/courses/${id}/notes/new`);
  };
  function handleFiltersQueryChange(queryValue) {
    refBoolPage.current = false;
    setQueryValue(queryValue);
  }
  function handleAvailabilityChange(availability) {
    setAvailability(availability);
  }
  const handleAvailabilityRemove = useCallback(() => setAvailability(""), []);
  const handleQueryValueRemove = useCallback(() => setQueryValue(""), []);
  const handleFiltersClearAll = useCallback(() => {
    handleAvailabilityRemove();
    handleQueryValueRemove();
  }, [handleAvailabilityRemove, handleQueryValueRemove]);

  const filters = [
    {
      key: "availability",
      label: "Filter by",
      filter: (
        <ChoiceList
          title="Filter by"
          titleHidden
          choices={[{ label: "Title", value: "title" }]}
          selected={availability || []}
          onChange={handleAvailabilityChange}
        />
      ),
      shortcut: false,
    },
  ];

  const appliedFilters = [];
  if (!isEmpty(availability)) {
    const key = "availability";
    appliedFilters.push({
      key,
      label: disambiguateLabel(key, availability),
      onRemove: handleAvailabilityRemove,
    });
  }
  const loadingMarkup = pageObject.isLoading ? <Loading /> : null;
  const emtyState = pageObject.isListEmpty ? (
    <div
      style={{
        display: "flex",
        justifyContent: "middle",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <div style={{ width: "25%" }}>
        <Image src={emptyListImage}></Image>
      </div>
      <div className="mb-3">
        <Text variant="bodyLg" as="p">
          No results found
        </Text>
      </div>
      <br />
    </div>
  ) : (
    pageObject.isLoading && (
      <div className="spinnerContainer">
        <div className="vertical-center">
          <Spinner size="large" />
        </div>
      </div>
    )
  );
  const refBoolPage = useRef(true);
  const handleChangePage = (event, value) => {
    refBoolPage.current = true;
    setPage(value);
  };
  const handleEdit = (param) => {
    navigate(`/admin/courses/${id}/notes/${param}`);
  };
  const handleEditPlaylists = (id) => {
    navigate(`/admin/notes/${id}/playlists`);
  };
  const handleEditFiles = (param) => {
    navigate(`/admin/courses/${id}/notes/${param}/files`);
  };
  const handleEditQuestions = (id) => {
    navigate(`/admin/notes/${id}/questions-and-answers`);
  };
  const handleSubscribers = (param) => {
    navigate(`/admin/courses/${id}/notes/${param}/subscribers`);
  };
  const [optionsUniversities, setOptionsUniversities] = useState([]);
  const [selectedUniversity, setSelectedUniversity] = useState("");
  const handleSelectChangeUniversity = (newValue) => {
    setSelectedUniversity(newValue);
  };
  const [selectedType, setSelectedType] = useState("");
  const handleSelectChangeType = (newValue) => {
    setSelectedType(newValue);
  };
  useEffect(() => {
    fetchData();
  }, [ts, availability, queryValue, page, selectedUniversity, selectedType]);

  async function fetchData() {
    let responseNotes = "";

    try {
      responseNotes = await axios.get(
        `/notes?per_page=${perPage}&page=${
          refBoolPage.current ? page : 1
        }&filter[course_id]=${id}${
          queryValue
            ? `&filter[${
                availability === "" ? "title" : availability
              }]=${queryValue}`
            : ""
        }${selectedType ? `&filter[type]=${selectedType}` : ""}`
      );
      setPageObject({
        ...pageObject,
        tableItems: responseNotes.data.data.data.map((item, index) => [
          item?.image && <Thumbnail size="extraSmall" source={item.image} />,
          item?.title ? getFirstNonNullValue(item.title) : "-",
          item?.price !== null ? item.price : "-",
          // item?.time !== null ? item.time : "-",
          // <Badge>{item.type.description}</Badge>,

          // item.type.description === "University" && item.university
          //   ? getFirstNonNullValue(item.university?.name)
          //   : "-",
          // item.type.description === "School" && item.school
          //   ? getFirstNonNullValue(item.school.name)
          //   : "-",
          // item.type.description === "School" && item.school_class
          //   ? getFirstNonNullValue(item.school_class.name)
          //   : "-",
          // item.type.description === "School" && item.subject
          //   ? getFirstNonNullValue(item.subject.name)
          //   : "-",
          // item.professors && item.professors.length ? (
          //   <div className="rowDiv">
          //     {item.professors.map((item) => {
          //       return (
          //         <div style={{ marginLeft: "7px" }} key={item.id}>
          //           <Tag>{getFirstNonNullValue(item.name)}</Tag>
          //         </div>
          //       );
          //     })}
          //   </div>
          // ) : (
          //   "-"
          // ),
          <Badge tone={item.is_active ? "success" : "info"}>
            {item.is_active ? "Active" : "Draft"}
          </Badge>,
          <ButtonGroup>
            {/* <Button variant="primary" onClick={() => handleEditFiles(item.id)}>
              Files
            </Button> */}
            <Button onClick={() => handleSubscribers(item.id)}>
              Subscribers
            </Button>
            <Button onClick={() => handleEdit(item.id)}>Edit</Button>
          </ButtonGroup>,
        ]),
        isLoading: false,
        isListEmpty: !responseNotes.data.data.data.length ? true : false,
        tableTotalPages: responseNotes.data.data.total,
      });
    } catch (error) {
      console.log(error);
    }

    // if (!featuresList.length)
    //   try {
    //     responseFeatures = await axios.get(`features`);
    //     setFeaturesList(
    //       responseFeatures.data.data.data.map((item, index) => {
    //         return {
    //           label: item.name,
    //           value: item.id,
    //         };
    //       })
    //     );
    //   } catch (error) {
    //     console.log(error);
    //   }
  }

  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const [toastContent, setToastContent] = useState(
    "This Note has been successfully deleted"
  );

  const toastMarkup = active ? (
    <Toast content={toastContent} onDismiss={toggleActive} />
  ) : null;

  return (
    <Page
      title="Notes"
      primaryAction={
        <Button variant="primary" onClick={handleAddNote}>
          Add Note
        </Button>
      }
      backAction={{
        onAction: () => navigate(`/admin/courses`),
      }}
    >
      <Card padding="0">
        {loadingMarkup}
        <FormLayout>
          {/* <div style={{ paddingRight: "1rem", paddingLeft: "1rem" }}>
            <Select
              label="Type"
              options={[
                { label: "All", value: "" },
                { label: "School", value: "1" },
                { label: "University", value: "2" },
              ]}
              onChange={handleSelectChangeType}
              value={selectedType}
              placeholder="Please select"
            />
          </div> */}
          {/* <FormLayout.Group>
            <FormLayout>
              <Text>University</Text>
              <Select2
                options={optionsUniversities}
                onChange={handleSelectChangeUniversity}
                value={selectedUniversity}
                placeholder="Please select a university"
                styles={{
                  // Fixes the overlapping problem of the component
                  menu: (provided) => ({ ...provided, zIndex: 9999 }),
                }}
              />
            </FormLayout>
          </FormLayout.Group> */}
          {/* <Filters
            queryValue={queryValue}
            queryPlaceholder="Search..."
            filters={filters}
            appliedFilters={appliedFilters}
            onQueryChange={handleFiltersQueryChange}
            onQueryClear={handleQueryValueRemove}
            onClearAll={handleFiltersClearAll}
          /> */}

          <DataTable
            columnContentTypes={["text", "text", "text", "text"]}
            headings={[
              <Text variant="bodyMd" as="p" fontWeight="medium">
                Image
              </Text>,
              <Text variant="bodyMd" as="p" fontWeight="medium">
                Title
              </Text>,

              <Text variant="bodyMd" as="p" fontWeight="medium">
                Price (KWD)
              </Text>,
              // <Text variant="bodyMd" as="p" fontWeight="medium">
              //   Duration
              // </Text>,
              // <Text variant="bodyMd" as="p" fontWeight="medium">
              //   Type
              // </Text>,
              // <Text variant="bodyMd" as="p" fontWeight="medium">
              //   University
              // </Text>,
              // <Text variant="bodyMd" as="p" fontWeight="medium">
              //   School
              // </Text>,
              // <Text variant="bodyMd" as="p" fontWeight="medium">
              //   Class
              // </Text>,
              // <Text variant="bodyMd" as="p" fontWeight="medium">
              //   Subject
              // </Text>,
              // <Text variant="bodyMd" as="p" fontWeight="medium">
              //   Subject
              // </Text>,
              // <Text variant="bodyMd" as="p" fontWeight="medium">
              //   Professors
              // </Text>,
              <Text variant="bodyMd" as="p" fontWeight="medium"></Text>,
              <Text variant="bodyMd" as="p" fontWeight="medium"></Text>,
            ]}
            rows={pageObject.tableItems}
            verticalAlign="middle"
            increasedTableDensity
            footerContent={
              pageObject.tableItems?.length &&
              `Showing ${pageObject.tableItems.length} of ${pageObject.tableTotalPages} results`
            }
            hasZebraStripingOnData
          />
        </FormLayout>
        {emtyState}
        {Math.ceil(pageObject.tableTotalPages / perPage) >= 2 && (
          <div
            style={{
              paddingTop: "10px",
              textAlign: "center",
              paddingBottom: "10px",
            }}
          >
            <Pagination
              variant="outlined"
              count={Math.ceil(pageObject.tableTotalPages / perPage)}
              page={page}
              onChange={handleChangePage}
            />
            {/* <Pagination
              count={Math.ceil(pageObject.tableTotalPages / perPage)}
              page={page}
              onChange={handleChangePage}
              size="large"
            /> */}
          </div>
        )}

        {toastMarkup}
      </Card>
    </Page>
  );
  function disambiguateLabel(key, value) {
    switch (key) {
      case "taggedWith":
        return `Tagged with ${value}`;
      case "availability":
        return `Filter by ${value}`;
      default:
        return value;
    }
  }
  function isEmpty(value) {
    if (Array.isArray(value)) {
      return value.length === 0;
    } else {
      return value === "" || value == null;
    }
  }
  function getFirstNonNullValue(obj) {
    for (const value of Object.values(obj)) {
      if (value !== null) {
        return value;
      }
    }
    return null;
  }
};

export default Notes;
